export default __webpack_public_path__ + "static/media/explorer.b1b285a1.svg";